import React, { useState } from 'react';
import {jsonResponseHandler} from "../../utils/FetchHelper";
import Thumbnail from "../../lib/Thumbnail";

function UploadProgressButton(props) {
  return (
    <span className="lab_btn btn_file">이미지 업로드 중</span>
  );
}

function UploadedButton(props) {
  const { value, onDelete, onFileSelected } = props;

  return (
    <div className="box_upload"
         style={{backgroundImage:`url(${Thumbnail.make('C100x80', value)})`}}>
      <label className="lab_btn btn_file"><span className="ico_blog">이미지 업로드</span><input type="file" className="btn_g" onChange={onFileSelected}/></label>
      <button type="button" className="btn_delete" onClick={onDelete}>이미지 삭제</button>
    </div>
  );
}

function EmptyButton(props) {
  const { onFileSelected } = props;

  return (
    <label className="lab_btn btn_file">이미지 업로드<input type="file" className="btn_g" onChange={onFileSelected}/></label>
  );
}

export default function ImageUploadButton(props) {
  const { value, onChange } = props;
  const [progress, setProgress] = useState(false);

  function handleUpload(e) {
    if (e.target.files && e.target.files.length === 0) {
      return;
    }

    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);

    setProgress(true);
    fetch('/manage/resource.json', {
      method: 'POST',
      credentials: 'include',
      body: formData
    })
      .then(jsonResponseHandler())
      .then(res => {
        if (res.ok) {
          return res.json()
        }
        throw res
      })
      .then(json => {
        onChange(json.url);
      })
      .finally(() => {
        setProgress(false);
      })
  }

  function handleClose(e) {
    e.stopPropagation();
    onChange(null);
  }

  if (progress) {
    return <UploadProgressButton />
  } else if (value) {
    return <UploadedButton value={value} onFileSelected={handleUpload} onDelete={handleClose} />
  } else {
    return <EmptyButton onFileSelected={handleUpload} />
  }
}
